import { Route, Navigate } from "react-router-dom";
import { ScoreWaterfall } from "./Tabs/2_TabActionPlan/ActionsPreview/ScoreWaterfall";
import { MainLayout } from "./MainLayout";
import { SynthesisLayout } from "./Tabs/1_TabTrajectories/SynthesisLayout";
import { SynthesisBarChart } from "./Tabs/1_TabTrajectories/Trajectory/SynthesisBarChart";
import { SynthesisCards } from "./Tabs/1_TabTrajectories/Synthesis/SynthesisCards";
import { OneInLocalStorage } from "src/services/OneFromLocalStorage";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { ActionPlanInit } from "./NoActionPlan/ActionPlanInit";
import { ActionPlanLayout } from "./Tabs/2_TabActionPlan/ActionPlanLayout";
import { ListPlanning } from "./Tabs/2_TabActionPlan/ActionList/List/ListPlanning";
import { EditPlanningProperties } from "./Tabs/2_TabActionPlan/ActionList/EditProperties/EditPlanningProperties";
import { Loading } from "../utils/Loading";

const noActionPlayKey = "noActionPlan" as const;

export const useActionPlanRouter = () => {
    return (
        <Route path="actions">
            <Route index element={<GlobalActionRedirect />} />
            <Route path={noActionPlayKey} element={<MainLayout />}>
                <Route index element={<ActionPlanInit />} />
            </Route>
            <Route path="trajectory" element={<MainLayout selectedSection="trajectory" />}>
                <Route index element={<TrajectoryRedirect />} />
                <Route path="barChart" element={<SynthesisLayout selectedButton="barChart" />}>
                    <Route index element={<SynthesisBarChart />} />
                </Route>
                <Route path="cards" element={<SynthesisLayout selectedButton="cards" />}>
                    <Route index element={<SynthesisCards />} />
                </Route>
            </Route>

            <Route path="planning" element={<MainLayout selectedSection="planning" />}>
                <Route index element={<PlanningRedirect />} />
                <Route path="list" element={<ActionPlanLayout selectedButton="list" />}>
                    <Route index element={<ListPlanning />} />
                    <Route path=":actionId" element={<EditPlanningProperties />} />
                </Route>
                <Route path="preview" element={<ActionPlanLayout selectedButton="preview" />}>
                    <Route index element={<ScoreWaterfall />} />
                </Route>
            </Route>
        </Route>
    );
};

const GlobalActionRedirect = () => {
    const { actionPlan, isFetched } = useActionsContext();

    if (isFetched === false) {
        return <Loading />;
    }

    if (actionPlan === null) {
        return <Navigate to={noActionPlayKey} replace />;
    }

    const existingMainTab = OneInLocalStorage.getItem("actionPlan-main-tabs");
    return <Navigate to={existingMainTab} replace />;
};

const TrajectoryRedirect = () => {
    const existingTrajectoryTab = OneInLocalStorage.getItem("actionPlan-trajectory-tabs");
    return <Navigate to={existingTrajectoryTab} replace />;
};

const PlanningRedirect = () => {
    const existingPlanningTab = OneInLocalStorage.getItem("actionPlan-planning-tabs");
    return <Navigate to={existingPlanningTab} replace />;
};
